import React from 'react';
import { AnimatedSection } from '../shared/AnimatedSection';
import { Sign } from '../../data/signs';
import { motion } from 'framer-motion';
import { startCheckout } from '../../lib/metaPixel';
interface SignCTAProps {
  sign: Sign;
}
export function SignCTA({
  sign
}: SignCTAProps) {
  const scrollToOffers = () => {
    const el = document.getElementById('sign-offers');
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    } else {
      startCheckout(sign.name, sign.checkoutUrl, 12.69);
    }
  };
  return <section className="py-24 md:py-32 px-4 md:px-6" style={{
    background: `radial-gradient(circle at center, ${sign.colors.primary}25 0%, #050508 70%)`
  }} data-id="element-862">
      <div className="container mx-auto max-w-3xl text-center" data-id="element-863">
        <AnimatedSection data-id="element-864">
          <h2 className="text-4xl md:text-6xl font-serif font-bold text-white mb-6 md:mb-8 leading-tight px-2" style={{
          textShadow: `0 0 40px ${sign.colors.primary}60`
        }} data-id="element-865">
            El Reino ya existe dentro de ti.
          </h2>
          <p className="text-xl md:text-3xl mb-10 md:mb-14 font-serif italic px-4" style={{
          color: sign.colors.accent
        }} data-id="element-866">
            Ahora puedes explorarlo desde una nueva perspectiva.
          </p>
        </AnimatedSection>

        <AnimatedSection delay={0.3} data-id="element-867">
          <motion.button onClick={scrollToOffers} className="inline-block w-full sm:w-auto px-10 md:px-14 py-5 md:py-6 text-lg md:text-xl font-bold rounded-xl transition-all duration-300 tracking-wide" style={{
          backgroundColor: sign.colors.primary,
          color: '#050508',
          boxShadow: `0 0 40px ${sign.colors.primary}60`
        }} whileHover={{
          scale: 1.05,
          boxShadow: `0 0 80px ${sign.colors.primary}90`
        }} whileTap={{
          scale: 0.95
        }} data-id="element-868">
            Desbloquear Mi Reino
          </motion.button>
        </AnimatedSection>
      </div>
    </section>;
}